import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import SportCategories from '@/pages/home/components/SportCategories';
import FeaturedEvents from '@/pages/home/components/FeaturedEvents';
import NewsSection from '@/pages/home/components/NewsSection';
import FAQSection from '@/pages/home/components/FAQSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <SportCategories />
        <FeaturedEvents />
        <NewsSection />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '开云体育在线',
            url: 'https://www.kaiyunsport.com/',
            description: '开云体育在线是您最值得信赖的体育娱乐平台，提供丰富的体育赛事投注、实时赔率更新、安全快捷的存取款服务。',
            publisher: {
              '@type': 'Organization',
              name: '开云体育在线',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '开云体育在线',
            url: 'https://www.kaiyunsport.com/',
            description: '开云体育在线 - 官方正品体育平台入口',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-888-9999',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '开云体育在线平台是否合法合规？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '开云体育在线持有国际合法运营牌照，严格遵守所在地法律法规，致力于为全球用户提供安全、公平、透明的体育娱乐服务。',
                },
              },
              {
                '@type': 'Question',
                name: '如何注册开云体育在线账号？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '注册流程：点击官网右上角"注册"按钮，填写手机号或邮箱地址，设置登录密码，完成验证即可。新用户注册即享专属欢迎礼包。',
                },
              },
              {
                '@type': 'Question',
                name: '平台支持哪些存取款方式？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '支持银行卡转账、USDT虚拟货币、微信支付、支付宝等多种支付渠道。存款即时到账，提款最快5分钟到账。',
                },
              },
              {
                '@type': 'Question',
                name: '平台提供哪些体育赛事投注？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '覆盖全球超过30种体育项目，包括足球、篮球、网球、电竞等，提供赛前投注和滚球投注两种模式。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}